import React from 'react';
import { Avatar, Box, Button, Card, CardActions, CardContent, Chip, Tooltip, Typography } from '@mui/material';
import './jobCard.css';

const JobCard = ({ item }) => {
  return (
    <Card className='card-root'>
      <Box className="content">
        <Chip variant='outlined' label={`⏳ Posted 10 days ago`} />
      </Box>
      <CardContent className='card-content'>
        <div className='company-info'>
          <img width={25} height={40} src={item?.logoUrl} alt={item.jbUid} />
          <div>
            <h3 className='company-name'>{item.companyName}</h3>
            <h2 className='role'>{item.jobRole}</h2>
            <p className='location'>{item.location}</p>
          </div>
        </div>
        <Typography variant='p' className='salary-range'>
          Estimated Salary: ${(item?.minJdSalary && item?.maxJdSalary)
            ? item?.minJdSalary + `${item?.minJdSalary && '-'}` + item?.maxJdSalary
            : (item?.minJdSalary || item?.maxJdSalary)} LPA
          <Tooltip title="Offered salary range" placement='top'> ✅</Tooltip>
        </Typography>
        <Box className="about-info">
          <Box>
            <Typography variant='p' className='about-label'>
              About Company:
            </Typography>
            <Box className="about-us">
              <p>
                <strong>About us:</strong>
              </p>
              <Typography variant='p' className='details'>
                {item?.jobDetailsFromCompany}
              </Typography>
              <p>&nbsp;</p>
              <p>
                <strong>Founder/Recruiter Profiles:</strong>
              </p>
              <p>
                <a href={item?.jdLink}></a>
              </p>
            </Box>
          </Box>
        </Box>
        <Box className='show-more-action'>
          <a>
            View job
          </a>
        </Box>
        <div className='info-container'>
          {item?.minExp
            && (
              <>
                <h3>
                  Minimum Experience
                </h3>
                <h2>
                  {item?.minExp} Years
                </h2>
              </>
            )
          }
        </div>
      </CardContent>
      <CardActions className='card-actions'>
        <Button className='apply-btn'>
          ⚡ Easy Apply
        </Button>
        <Button color='primary' size='medium' className='referral-btn'>
          <Avatar className='avatar' alt="Travis Howard" src="/user1.jpeg" />
          <Avatar className='avatar' alt="Travis Howard" src="/user2.jpeg" />
          &nbsp;
          Unlock referral asks
        </Button>
      </CardActions>
    </Card>
  )
}

export default JobCard;
